'use strict'
function showTooltip(tooltip) {
    removeTooltip()
    let htmlJson = tooltip.dataset.html
    if (htmlJson) {
        let html = JSON.parse(htmlJson)
        if (html) {
            let tooltipText = document.createElement('div')
            tooltipText.innerHTML = html
            tooltipText.id = 'tooltip_text'

            if (window.innerWidth < 340) {
                tooltipText.style.width = '100%'
            }

            document.body.append(tooltipText)

            let x = tooltip.getBoundingClientRect().x + tooltip.getBoundingClientRect().width / 2 - tooltipText.getBoundingClientRect().width / 2
            let y = tooltip.getBoundingClientRect().y + window.scrollY - tooltipText.getBoundingClientRect().height

            if (x < 0) {
                x = 0
            } else if (x + tooltipText.getBoundingClientRect().width > window.innerWidth) {
                x = window.innerWidth - tooltipText.getBoundingClientRect().width
            }

            if (y < 0) {
                y = 0
            }

            tooltipText.style.left = x + 'px'
            tooltipText.style.top = y + 'px'
        }
    }
}

function removeTooltip() {
    let tooltipText = document.getElementById('tooltip_text')
    if (tooltipText) {
        tooltipText.remove()
    }
}

if (('ontouchstart' in window)) {
    function removeTouchendClass() {
        document.querySelectorAll('.tooltip.touchend').forEach((tooltip) => {
            tooltip.classList.remove('touchend')
        })
    }

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.tooltip').forEach((tooltip) => {
            tooltip.addEventListener('touchend', () => {
                if (tooltip.classList.contains('touchend')) {
                    removeTouchendClass()
                    removeTooltip()
                } else {
                    removeTouchendClass()
                    tooltip.classList.add('touchend')
                    showTooltip(tooltip)
                }
            })
        })
        document.addEventListener('touchend', (event) => {
            let tooltipText = document.getElementById('tooltip_text')
            if (tooltipText && !event.target.closest('.tooltip') && !event.target.closest('#tooltip_text')) {
                removeTouchendClass()
                tooltipText.remove()
            }
        })
        document.addEventListener('touchmove', () => {
            removeTouchendClass()
            removeTooltip()
        })
    })
} else {
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.tooltip').forEach((tooltip) => {
            tooltip.addEventListener('mouseover', () => {
                showTooltip(tooltip)
            })
        })
        document.addEventListener('mousemove', () => {
            let tooltip = document.querySelector('.tooltip:hover')
            let tooltipText = document.getElementById('tooltip_text')
            if (!tooltip && tooltipText && !tooltipText.matches(':hover')) {
                tooltipText.remove()
            }
        })
    })
}